<script>
	import Button from "./Button.svelte";
</script>

<section class="section">
	<div class="container">
		<h2 class="h1 section__title tac b">Get started now</h2>
		<div class="pricing-block">
			<div class="pricing-block__row">
				<div class="pricing-block__column">
					<h2 class="h1 pricing-block__title b">1% out of Gross </h2>
					<p class="h4 pricing-block__text">Try all the possibilities of Loder to achieve the best results</p>
				</div>
				<div class="pricing-block__column">
					<p class="pricing-block__info h4"><span class='h4 b'>1 month free</span> use of the platform</p>
					<p class="pricing-block__info h4">Unlimited access to all features</p>
				</div>
			</div>
			<Button width='150px' label='Start free trial' ></Button>
		</div>
	</div>
</section>

<style>
	.section {
		padding: 150px 0;
		background: var(--system-background-secondary);
	}
	.section__title {
		margin: 0 0 70px; 
	}
	.tac {
		text-align: center;
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
	}
	.pricing-block {
		max-width: 1160px;
		width: 100%;
		margin: 0 auto;
		border-radius: 20px;
		background: url('../assets/img/pricing-bg.png') no-repeat;
		background-position: right;
		background-size: cover;
		padding: 70px 100px;
		box-sizing: border-box;
	}
	.pricing-block__row {
		display: flex;
		margin-bottom: 35px;
		gap: 140px;
	}
	.pricing-block__column {
		display: flex;
		flex-direction: column;
	}
	.pricing-block__text {
		max-width: 320px;
		color: var(--text-color-secondary);
		margin: 35px 0 0;
	}
	.pricing-block__title {
		margin: 0;
		color: var(--color-primary-500);
	}
	.pricing-block__info {
		background-color: var(--system-background-secondary);
		max-width: 400px;
		border-radius: 10px;
		padding: 15px 35px;
		margin: 0;
	}
	.pricing-block__info:last-child {
		margin-top: 20px;
	}
	.pricing-block__info .b {
		color: var(--color-primary-500);
		font-size: inherit;
		line-height: inherit;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
		.section {
			padding: 120px 0;
		}
		.section__title {
			font-size: 32px;
			line-height: 40px;
		}
		.pricing-block {
			max-width: 100%;
			padding: 60px;
		}
		.pricing-block__row {
			gap: 64px;
		}
		.pricing-block__title {
			font-size: 32px;
			line-height: 40px;
		}
		.pricing-block__text {
			font-size: 20px;
			margin-top: 20px;
		}
		.pricing-block__info {
			font-size: 20px;
			line-height: 25px;
			max-width: 343px;
			color: var(--text-color-secondary);
		}
		
	}
	@media(max-width: 960px) {
		.container {
			max-width: 640px;
		}
		.pricing-block {
			padding: 60px 135px 120px;
			align-items: center;
			display: flex;
			flex-direction: column;
		}
		.pricing-block__row {
			flex-direction: column;
			align-items: center;
			gap: 25px;
		}
		.pricing-block__text {
			text-align: center;
		}
		.pricing-block__title {
			text-align: center;
		}
		.pricing-block__info {
			font-size: 20px;
			line-height: 25px;
			width: 100%;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 480px;
		}
		.section__title {
			font-size: 24px;
			line-height: 30px;
		}
		.section {
			padding: 100px 0;
		}
		.pricing-block {
			padding: 50px 80px 100px;
		}
		.pricing-block__title {
			font-size: 24px;
			line-height: 30px;
		}
		.pricing-block__text {
			font-size: 14px;
			line-height: 17px;
			max-width: 183px;
			margin-top: 20px;
		}
		.pricing-block__row {
			margin-bottom: 20px;
		}
		.pricing-block__info {
			font-size: 16px;
			line-height: 20px;
		}
	}
	@media(max-width: 480px) {
		.section__title {
			max-width: 200px;
			margin: 0 auto 40px;
		}
		.container {
			max-width: 32s0px;
		}
		.section {
			padding: 70px 0;
		}
		.pricing-block {
			padding: 35px 30px 45px;
			background: var(--system-background-primary);
		}
		.pricing-block__info {
			padding: 10px;
		}
		.pricing-block__info:last-child {
			margin-top: 10px;
		}
	}
</style>